import PropTypes from "prop-types";

export const fieldPropTypes = {
  input: PropTypes.shape({
    checked: PropTypes.bool,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.any.isRequired
  }).isRequired,
  meta: PropTypes.shape({
    invalid: PropTypes.bool.isRequired,
    error: PropTypes.string.isRequired,
    touched: PropTypes.bool.isRequired
  })
};
